<template>
  <div>
    <van-form class="mt10">
      <van-field
        input-align="right"
        v-model="formData.Amount"
        label="申报金额"
        placeholder="请输入"
        :rules="[{ required: true, message: '请输入申报金额' }]"
      />
      <van-field
        input-align="right"
        v-model="formData.InvType"
        label="收款类别"
        placeholder="请输入"
        :rules="[{ required: true, message: '请输入收款类别' }]"
      />
      <van-field
        input-align="right"
        readonly
        clickable
        name="picker"
        :value="formData.RPer"
        label="付款方"
        placeholder="请选择"
        @click="showPayer = true"
      />
      <van-field
        input-align="right"
        readonly
        clickable
        :value="formData.Date"
        label="申报日期"
        placeholder="请选择"
        @click="showPaymentDate = true"
      />
      <van-field
        input-align="right"
        readonly
        clickable
        :value="formData.RPType"
        label="收款方式"
        placeholder="请选择"
        @click="showPaymentMethod = true"
      />
      <van-field
        input-align="right"
        readonly
        clickable
        :value="formData.subcategory"
        label="收款账户"
        placeholder="请选择"
        @click="showPaymentAccount = true"
      />
      <van-field
        input-align="right"
        readonly
        clickable
        :value="formData.Currency"
        label="货币"
        placeholder="请选择"
        @click="showCurrency = true"
      />
      <van-field
        input-align="right"
        :value="formData.InvType"
        label="支出类别"
        placeholder="请输入"
      />
      <van-field
        input-align="right"
        :value="formData.InvType"
        label="详细类别"
        placeholder="请输入"
      />
      <van-field
        input-align="right"
        :value="formData.InvType"
        label="凭证号"
        placeholder="请输入"
      />
    </van-form>
    <van-row class="mt10" :gutter="5">
      <van-col :span="12">
        <van-button block type="primary" plain>上传附件</van-button>
      </van-col>
      <van-col :span="12">
        <van-button block type="primary" @click="submitUpdRece()">提交</van-button>
      </van-col>
    </van-row>
    <!--付款方-->
    <van-popup v-model="showPayer" position="bottom">
      <van-picker
        show-toolbar
        :columns="popupData.payerList"
        @confirm="onPayerConfirm"
        @cancel="showPayer = false"
      />
    </van-popup>
    <!--申报日期-->
    <van-popup v-model="showPaymentDate" position="bottom">
      <van-datetime-picker
        type="date"
        @confirm="onShowPaymentDateConfirm"
        @cancel="showPaymentDate = false"
      />
    </van-popup>
    <!--收款方式-->
    <van-popup v-model="showPaymentMethod" position="bottom">
      <van-picker
        show-toolbar
        :columns="popupData.paymentType"
        @confirm="onRPTypeConfirm"
        @cancel="showPaymentMethod = false"
      />
    </van-popup>
    <!--收款账户-->
    <van-popup v-model="showPaymentAccount" position="bottom">
      <van-picker
        show-toolbar
        :columns="popupData.paymentAccount"
        @confirm="onPaymentAccountConfirm"
        @cancel="showFundCategory = false"
      />
    </van-popup>
    <!--货币-->
    <van-popup v-model="showCurrency" position="bottom">
      <van-picker
        show-toolbar
        :columns="popupData.currency"
        @confirm="onCurrencyConfirm"
        @cancel="showCurrency = false"
      />
    </van-popup>
  </div>
</template>

<script>
  import {
    getPartnersAllFun,
    getBankInfoFun,
    getPayOrReceivablesTypeFun,
    getStreamAccountShipFun,
    createReceivablesRecordFun,
    getReceivablesListFun,
    updReceivablesDeclareCustomerFun
  } from '@/api/payment'
  import {getCurrencyApi} from "@/api/regist";
  import {Toast} from 'vant'

  export default {
    name: "Declaration",
    data() {
      return {
        formData: {
          GUID: '58932e79-0a06-4a2e-89e6-6379fdc7514e',
          C_GUID: this.getCookie('CompanyInfo').companyId,
          VoucherNo: '11111',
          Amount: '',//金额
          InvType: '',//收款类别
          RPer: '',//付款方
          Date: '',//申报日期
          RPType: '',//收款方式
          subcategory: '',//收款账户
          Currency: '',//货币
          State: '',
          Business_GUID: '',
          SubBusiness_GUID: '',
          DetailRPType: '',
          Remark: '',
        },
        showPayer: false,//付款方弹窗
        showPaymentDate: false,//付款日期
        showPaymentMethod: false,//收款方式
        showPaymentAccount: false,//收款账户
        showCurrency: false,//货币
        popupData: {
          payerList: [],//付款方
          fundCategory: [],//资金类别
          paymentAccount: [],//付款账户
          currency: [],//货币
          paymentType: [],//收款方式
          paymentSubType: [],//付款子类别
        },
      }
    },
    mounted() {
      this.getCurrency();
      this.getCustomer();
      this.getBankInfo();
      this.getPayOrReceivablesType()
    },
    methods: {
      onPayerConfirm(value) {
        this.showPayer = false;
        this.formData.RPer = value.text;
      },
      onPaymentAccountConfirm(value) {
        this.showPaymentAccount = false;
        this.formData.subcategory = value.text;
      },
      onShowPaymentDateConfirm(value) {
        this.showPaymentDate = false;
        this.formData.Date = this.moment(value).format('YYYY-MM-DD');
      },
      onCurrencyConfirm(value) {
        this.showCurrency = false;
        this.formData.Currency = value.text;
      },
      onRPTypeConfirm(value) {
        this.showPaymentMethod = false;
        this.formData.RPType = value.text;
      },
      //付款单位
      async getCustomer() {
        const params = {
          C_GUID: this.getCookie('CompanyInfo').companyId
        };
        const response = await getPartnersAllFun(params);
        if (response.success) {
          response.result.map(item => {
            this.popupData.payerList.push({
              text: item.Name,
              value: item.BP_GUID
            })
          });
        }
      },
      //银行账户
      async getBankInfo() {
        const params = {
          cGuid: this.getCookie('CompanyInfo').companyId
        };
        const response = await getBankInfoFun(params);
        if (response.success) {
          const {success, ...otherData} = response;
          Object.values(otherData).map(item => {
            this.popupData.paymentAccount.push({
              text: item.label,
              value: item.value
            })
          })
        }
      },
      //资金类别
      async getPayOrReceivablesType() {
        const params = {
          cGuid: this.getCookie('CompanyInfo').companyId
        };
        const response = await getPayOrReceivablesTypeFun(params);
        if (response.success) {
          const {success, ...otherData} = response;
          Object.values(otherData).map(item => {
            this.popupData.paymentType.push({
              text: item.label,
              value: item.value,
            })
          })
        }
      },
      //货币类型
      async getCurrency() {
        const response = await getCurrencyApi();
        if (response.success) {
          response.result.map(item => {
            this.popupData.currency.push({
              text: item.Code,
              value: item.Code
            })
          });
        }
      },
      async submitUpdRece() {
        const response = await updReceivablesDeclareCustomerFun(this.formData);
        if (response.success)
          this.$router.push({path: "/home"})
      }
    }
  }
</script>

<style scoped>
  .Centermain li {
    border-bottom: 1px solid #d8d8d8;
  }

  .Centermain {
    margin-top: 1.5rem;
    background: #ffffff;

  }

  .inCon {
    padding: 0 1.9rem
  }

  .inCon1 {
    height: 4.6rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #f6f6f6;
  }

  .inCon1 p {
    width: 12rem;
    height: 100%;
    line-height: 4.6rem;
    font-size: 1.5rem;
    color: black;
    font-weight: bold;
  }

  .inCon1 input {
    display: block;
    width: 13rem;
    height: 4.6rem;
    font-size: 2.3rem;
    text-align: right;
  }

  .inCon2 {
    height: 5rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #f6f6f6;
  }

  .inCon2 p {
    font-size: 1.3rem;
    color: black;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .inCon2 input {
    display: block;
    font-size: 1.4rem;
    text-align: right;
  }

  .inCon2 img {
    width: 1.2rem;
    height: 0.7rem;
  }

  .inCon3 {
    height: 5rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #f6f6f6;
  }

  .inCon3 p {
    font-size: 1.3rem;
    color: black;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .inCon3 p:last-child {
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .inCon3 input {
    display: block;
    width: 10rem;
    height: 5rem;
    font-size: 0.13rem;
    color: black;
    text-align: right
  }

  .inCon3 img {
    width: 1.2rem;
    height: 0.7rem;
  }

  footer {
    display: flex;
    height: 4rem;
    background: white;
    justify-items: center;
    align-items: center;
  }

  .btn {
    margin: 0 auto;
    width: 12rem;
    height: 3.2rem;
    background: #09a9bf;
    font-size: 1.4rem;
    text-align: center;
    line-height: 3.2rem;
    border-radius: 20px;
  }

  .btn1 {
    margin: 0 auto;
    width: 12rem;
    height: 3.2rem;
    background: #379ce2;
    font-size: 1.4rem;
    text-align: center;
    line-height: 3.2rem;
    border-radius: 20px;
  }
</style>
